import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import Constant from '../../Constant';
import BarLoader from 'react-bar-loader';

export default class Courses extends Component {
  state = {
    loading: true,
    data: [],
    columns: [
      {
        name: 'Image',
        selector: 'image',
        sortable: true,
        width: '100px',
        cell: row => (
          <img src={row.image !== ""
            ? row.image
            : "./images/homepage/placeholder-img.jpg"
          } alt="" className="image_square py-2" onError={e => {
            e.target.src = "./images/homepage/placeholder-img.jpg"
          }} />
        )
      },
      {
        name: 'Name',
        selector: 'name',
        sortable: true,
      },
      {
        name: 'Code',
        selector: 'uniqueCourseID',
        sortable: true,
        width: '100px'
      },
      {
        name: 'Category',
        selector: 'categoryName',
        sortable: true,
        width: '250px'
      },
      {
        name: 'Enrollment Start Date',
        selector: 'startDate',
        sortable: true,
        width: '100px'
      },
      {
        name: 'Options',
        selector: 'id',
        sortable: true,
        cell: row => (
          <div className="d-flex">
            <Link to={`/admin/course/${row.id}`} className="btn btn-light shadow-sm mx-1 text-dark">
              <div>
                <i class="fas fa-pencil-alt" id={row.id}></i>
                <br />
                <label>Edit</label>
              </div>
            </Link>
            {/* <div>
              <i class="btn btn-light shadow-sm mx-1 fas fa-times text-danger" id={row.id} onClick={this.deleteCourse}            ></i>
              <br />
              <label>Delete</label>
            </div> */}

            {
              localStorage.getItem('livelms_role') === 'trainer'
                ?
                row.isEnrolled === true
                  ?
                  <button
                    class="btn btn-danger shadow-sm mx-1"
                    id={row.id}
                    onClick={this.onRemoveEnrollUser}
                  >
                    Remove
                  </button>
                  :
                  <button
                    class="btn shadow-sm mx-1 btn-primary"
                    id={row.id}
                    onClick={this.onEnrollUser}
                  >
                    Enroll
                    </button>

                :
                <Link to={`/admin/course/assign/${row.id}`} className="btn btn-light shadow-sm mx-1 text-dark">
                  <div>
                    <i class="fas fa-check" id={row.id}></i>
                    <br />
                    <label>Assign Users</label>
                  </div>
                </Link>
            }
            <Link to={`/admin/course/topics/${row.id}`} className="btn btn-light shadow-sm mx-1 text-dark">
              <i
                class="fas fa-share"
                id={row.id}></i>
              <br />
              <label>Topics</label>
            </Link>
          </div>
        ),
      },
    ],
  };
  componentDidMount() {
    if (localStorage.getItem('livelms_role') === 'trainer') {
      this.getEnrolledCourses();
    } else {
      this.getCourses();
    }
  }

  getEnrolledCourses = () => {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    myHeaders.append('Authorization', localStorage.getItem('livelms_auth'));

    var urlencoded = new URLSearchParams();
    urlencoded.append('siteId', localStorage.getItem('lms_site_id'));

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow',
    };

    fetch(Constant.getSiteAPI() + '/course/getAll', requestOptions)
      .then(response => response.json())
      .then(result => {
        var data = result.data;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = JSON.parse(data[i].content);
          var start_date = str.startDate
          var date = new Date(start_date);
          if (data[i].category) {
            data[i].categoryName = data[i].category.name;
          }
          console.log(data[i].categoryName);
          data[i].startDate = `${date.getUTCDate()}-${date.getUTCMonth() +
            1}-${date.getUTCFullYear()}`;
        }
        this.setState({ data: data, loading: false });
      })
      .catch(error => console.log('error', error));
  };
  getCourses = () => {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    myHeaders.append('Authorization', localStorage.getItem('livelms_auth'));

    var urlencoded = new URLSearchParams();
    urlencoded.append('siteId', localStorage.getItem('lms_site_id'));

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow',
    };

    fetch(Constant.getAPI() + '/course/getAll', requestOptions)
      .then(response => response.json())
      .then(result => {
        var data = result.data;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = JSON.parse(data[i].content);
          var start_date = str.startDate
          var date = new Date(start_date);
          if (data[i].category) {
            data[i].categoryName = data[i].category.name;
          }
          console.log(data[i].categoryName);
          data[i].startDate = `${date.getUTCDate()}-${date.getUTCMonth() +
            1}-${date.getUTCFullYear()}`;
        }
        this.setState({ data: data, loading: false });
      })
      .catch(error => console.log('error', error));
  };

  deleteCourse = e => {
    var courseId = e.target.id;
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    myHeaders.append('Authorization', localStorage.getItem('livelms_auth'));

    var urlencoded = new URLSearchParams();
    urlencoded.append('courseId', courseId);
    urlencoded.append('siteId', localStorage.getItem('lms_site_id'));

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow',
    };

    fetch(Constant.getAPI() + '/course/delete', requestOptions)
      .then(response => response.json())
      .then(result => {
        document.location.reload();
      })
      .catch(error => console.log('error', error));
  };
  onEnrollUser = (event) => {
    console.log(event.target.id);
    var courseId = event.target.id;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("userId", localStorage.getItem("lms_uid"));
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", courseId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/enroll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // document.location.reload();
        if (result.status === true) {
          this.getCourses();
        }
      })
      .catch((error) => console.log("error", error));
  };
  onRemoveEnrollUser = (event) => {
    console.log(event.target.id);
    var courseId = event.target.id;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("userId", localStorage.getItem("lms_uid"));
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", courseId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/unEnroll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // document.location.reload();
        if (result.status === true) {
          this.getCourses();
        }
      })
      .catch((error) => console.log("error", error));
  };
  render() {
    return (
      <div>
        <div className="py-3">
          <div className="container border shadow-sm p-0 bg-white">
            <div className="header bg-primary text-white">
              <div className="row m-0">
                <div className="col-md-6 p-3 d-flex align-items-center">
                  <h5 className="m-0">
                    <Link to="/admin/dashboard">Home</Link> /<b> Courses</b>
                  </h5>
                </div>
                <div className="col-md-6 d-flex justify-content-end align-items-center">
                  <Link
                    to="/admin/add-course"
                    className="btn btn-dark float-right">
                    Add Course
                  </Link>
                </div>
              </div>
            </div>

            <div className="users-container p-2">
              {this.state.loading == true ? (
                <div className="container p-5">
                  <div className="col-md-3 mx-auto">
                    <BarLoader color="#33cabb" height="4" />
                  </div>
                </div>
              ) : (
                  <DataTable
                    noHeader={true}
                    columns={this.state.columns}
                    data={this.state.data}
                    theme="solarized"
                    responsive={true}
                    pagination={true}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
